// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.platform-filters {
  display: flex;
  padding: 6px;
  padding-bottom: 0px;
  border-radius: 8px;
  gap: 16px;
  flex-wrap: wrap;
}

.charts-title-download {
  margin-bottom: 1.2rem;
}

.download-header-parent {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.platform-filter {
  all: unset;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 14px;
  border: 2px solid transparent;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  background-color: #ffffff;
  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 0 0 1px #e3e4e7;
  box-sizing: border-box;
  opacity: 0.65;
}

.platform-filter:hover {
  background-color: #f4f4f4;
  /* box-shadow: 0 0 0 1px #9ca3af; */
  opacity: 0.9;
}

.platform-filter.active {
  background-color: #fbf9ff;
  color: #5616ea;
  font-weight: 500;
  opacity: 1;
  box-shadow: none;
}

.platform-filter.active:hover {
  background-color: #f5eeff;
  box-shadow: none;
}

/* Animated SVG border that draws from the top-left corner clockwise
   around the chip whenever the chip becomes active. */
.platform-filter-border-svg {
  position: absolute;
  inset: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  overflow: visible;
  pointer-events: none;
  z-index: 1;
}

.platform-filter-border-rect {
  x: 0.5px;
  y: 0.5px;
  width: calc(100% - 1px);
  height: calc(100% - 1px);
  rx: 8px;
  ry: 8px;
  fill: none;
  stroke: #5616ea;
  stroke-width: 1px;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  /* No vector-effect here: non-scaling-stroke makes browsers compute the dash
     pattern in screen space, where pathLength="100" no longer normalises it —
     at fractional devicePixelRatios the border then never closes when drawn
     and leaves stray segments when hidden. The svg is unscaled, so the
     property bought nothing. */
  shape-rendering: geometricPrecision;
}

.platform-filter.active .platform-filter-border-rect {
  animation: platformFilterBorderDraw 0.7s ease-out forwards;
}

/* When a chip becomes deselected, the line "un-draws" — same path, opposite
   direction. Both keyframes have explicit \`from\` so the animation forces its
   starting offset on the first frame, which avoids any flicker that would
   otherwise come from the property reverting to the base value during the
   rule swap. */
.platform-filter:not(.active) .platform-filter-border-rect {
  animation: platformFilterBorderUndraw 0.7s ease-out forwards;
}

@keyframes platformFilterBorderDraw {
  from { stroke-dashoffset: 100; }
  to   { stroke-dashoffset: 0; }
}

@keyframes platformFilterBorderUndraw {
  from { stroke-dashoffset: 0; }
  to   { stroke-dashoffset: 100; }
}

.platform-filter-count {
  position: absolute;
  top: -10px;
  left: -7px;
  z-index: 2;
  background-color: #ffffff;
  color: #111827;
  border-radius: 999px;
  font-size: 11px;
  padding: 1px 7px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid #d1d5db;
  min-width: 18px;
  text-align: center;
  box-sizing: border-box;
}

.platform-filter.active .platform-filter-count {
  background-color: #fdfcff;
  border-color: #5616ea;
  color: #5616ea;
}

.no-chat-history-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  text-align: center;
}

.no-chat-history-message p {
  margin: 0;
  color: #6b7280;
  font-size: 15px;
}

/* Connect platform prompt */
.connect-platform-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background-color: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  text-align: center;
}

.connect-platform-prompt .connect-platform-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.connect-platform-prompt h3 {
  margin: 0 0 8px 0;
  color: #111827;
  font-size: 18px;
  font-weight: 600;
}

.connect-platform-prompt p {
  margin: 0 0 24px 0;
  color: #6b7280;
  font-size: 15px;
  max-width: 400px;
}

.connect-platform-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background-color: #5616ea;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.connect-platform-btn:hover {
  background-color: #4a14d6;
}

@media (max-width: 768px) {
  .platform-filters {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    gap: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 8px;
    flex-wrap: nowrap;
  }

  .platform-filter {
    padding: 8px 12px;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
  }
}

/* Inbox failed to load its conversation list — inline error with retry
   (the global API-error modal is suppressed for /chat_sessions). */
.inbox-load-error {
  flex-direction: column;
  gap: 12px;
}

.inbox-retry-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border: 1px solid #5616ea;
  border-radius: 10px;
  background-color: #fdfcff;
  color: #5616ea;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.inbox-retry-button:hover {
  background-color: #f1ebff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatHistories.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,oGAAoG;EACpG,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;sDACsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,uBAAuB;EACvB,wBAAwB;EACxB,OAAO;EACP,OAAO;EACP,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB;;;;+BAI6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;;;eAIe;AACf;EACE,4DAA4D;AAC9D;;AAEA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,OAAO,sBAAsB,EAAE;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;mEACmE;AACnE;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".platform-filters {\r\n  display: flex;\r\n  padding: 6px;\r\n  padding-bottom: 0px;\r\n  border-radius: 8px;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.charts-title-download {\r\n  margin-bottom: 1.2rem;\r\n}\r\n\r\n.download-header-parent {\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.platform-filter {\r\n  all: unset;\r\n  position: relative;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 8px 14px;\r\n  border: 2px solid transparent;\r\n  border-radius: 8px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #6b7280;\r\n  background-color: #ffffff;\r\n  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease, box-shadow 0.15s ease;\r\n  box-shadow: 0 0 0 1px #e3e4e7;\r\n  box-sizing: border-box;\r\n  opacity: 0.65;\r\n}\r\n\r\n.platform-filter:hover {\r\n  background-color: #f4f4f4;\r\n  /* box-shadow: 0 0 0 1px #9ca3af; */\r\n  opacity: 0.9;\r\n}\r\n\r\n.platform-filter.active {\r\n  background-color: #fbf9ff;\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n  opacity: 1;\r\n  box-shadow: none;\r\n}\r\n\r\n.platform-filter.active:hover {\r\n  background-color: #f5eeff;\r\n  box-shadow: none;\r\n}\r\n\r\n/* Animated SVG border that draws from the top-left corner clockwise\r\n   around the chip whenever the chip becomes active. */\r\n.platform-filter-border-svg {\r\n  position: absolute;\r\n  inset: -2px;\r\n  width: calc(100% + 4px);\r\n  height: calc(100% + 4px);\r\n  overflow: visible;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n\r\n.platform-filter-border-rect {\r\n  x: 0.5px;\r\n  y: 0.5px;\r\n  width: calc(100% - 1px);\r\n  height: calc(100% - 1px);\r\n  rx: 8px;\r\n  ry: 8px;\r\n  fill: none;\r\n  stroke: #5616ea;\r\n  stroke-width: 1px;\r\n  stroke-dasharray: 100;\r\n  stroke-dashoffset: 100;\r\n  /* No vector-effect here: non-scaling-stroke makes browsers compute the dash\r\n     pattern in screen space, where pathLength=\"100\" no longer normalises it —\r\n     at fractional devicePixelRatios the border then never closes when drawn\r\n     and leaves stray segments when hidden. The svg is unscaled, so the\r\n     property bought nothing. */\r\n  shape-rendering: geometricPrecision;\r\n}\r\n\r\n.platform-filter.active .platform-filter-border-rect {\r\n  animation: platformFilterBorderDraw 0.7s ease-out forwards;\r\n}\r\n\r\n/* When a chip becomes deselected, the line \"un-draws\" — same path, opposite\r\n   direction. Both keyframes have explicit `from` so the animation forces its\r\n   starting offset on the first frame, which avoids any flicker that would\r\n   otherwise come from the property reverting to the base value during the\r\n   rule swap. */\r\n.platform-filter:not(.active) .platform-filter-border-rect {\r\n  animation: platformFilterBorderUndraw 0.7s ease-out forwards;\r\n}\r\n\r\n@keyframes platformFilterBorderDraw {\r\n  from { stroke-dashoffset: 100; }\r\n  to   { stroke-dashoffset: 0; }\r\n}\r\n\r\n@keyframes platformFilterBorderUndraw {\r\n  from { stroke-dashoffset: 0; }\r\n  to   { stroke-dashoffset: 100; }\r\n}\r\n\r\n.platform-filter-count {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: -7px;\r\n  z-index: 2;\r\n  background-color: #ffffff;\r\n  color: #111827;\r\n  border-radius: 999px;\r\n  font-size: 11px;\r\n  padding: 1px 7px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border: 1px solid #d1d5db;\r\n  min-width: 18px;\r\n  text-align: center;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.platform-filter.active .platform-filter-count {\r\n  background-color: #fdfcff;\r\n  border-color: #5616ea;\r\n  color: #5616ea;\r\n}\r\n\r\n.no-chat-history-message {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  background-color: #f9fafb;\r\n  border: 1px dashed #d1d5db;\r\n  border-radius: 14px;\r\n  text-align: center;\r\n}\r\n\r\n.no-chat-history-message p {\r\n  margin: 0;\r\n  color: #6b7280;\r\n  font-size: 15px;\r\n}\r\n\r\n/* Connect platform prompt */\r\n.connect-platform-prompt {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px 24px;\r\n  background-color: #f9fafb;\r\n  border: 1px dashed #d1d5db;\r\n  border-radius: 14px;\r\n  text-align: center;\r\n}\r\n\r\n.connect-platform-prompt .connect-platform-icon {\r\n  font-size: 48px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.connect-platform-prompt h3 {\r\n  margin: 0 0 8px 0;\r\n  color: #111827;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.connect-platform-prompt p {\r\n  margin: 0 0 24px 0;\r\n  color: #6b7280;\r\n  font-size: 15px;\r\n  max-width: 400px;\r\n}\r\n\r\n.connect-platform-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 12px 24px;\r\n  background-color: #5616ea;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.connect-platform-btn:hover {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .platform-filters {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    overflow-x: auto;\r\n    gap: 12px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    padding-left: 8px;\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .platform-filter {\r\n    padding: 8px 12px;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n/* Inbox failed to load its conversation list — inline error with retry\r\n   (the global API-error modal is suppressed for /chat_sessions). */\r\n.inbox-load-error {\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.inbox-retry-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 8px 18px;\r\n  border: 1px solid #5616ea;\r\n  border-radius: 10px;\r\n  background-color: #fdfcff;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.inbox-retry-button:hover {\r\n  background-color: #f1ebff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
